/**
 * @since     1.0.0
 * @author    Jonas Hartmann <mail@inoas.com>
 * @license   For full copyright and license information, please see the LICENSE.txt.
 */
'use strict';

var debug = function (variable) {
    console.log(variable);
    console.log((new Error()).stack);
}

if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, rawPos) {
            var pos = rawPos > 0 ? rawPos|0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

if (!String.prototype.trimStart) {
    String.prototype.trimStart = function() {
        return this.replace(/^\s+/,"");
    }
}

if (!String.prototype.leftTrim) {
    String.prototype.leftTrim = function() {
        return this.replace(/^\s+/,"");
    }
}

var humanizeStr = function (string) {
    return string
        .replace(/^[\s_]+|[\s_]+$/g, '')
        .replace(/[_\s]+/g, ' ')
        .replace(/^[a-z]/, function(match) { return match.toUpperCase(); });
};

// BEGIN https://plainjs.com/javascript/events/trigger-an-event-11/
var triggerEvent = function (el, type){
    if ('createEvent' in document) {
         // modern browsers, IE9+
         var e = document.createEvent('HTMLEvents');
         e.initEvent(type, false, true);
         el.dispatchEvent(e);
     } else {
         // IE 8
         var e = document.createEventObject();
         e.eventType = type;
         el.fireEvent('on'+e.eventType, e);
     }
 }
 // END https://plainjs.com/javascript/events/trigger-an-event-11/

var removeFromArrayByValue = function (array, value) {
    var index = array.indexOf(value);
    if (value !== -1) {
        return array.splice(index, 1);
    }
    return null;
};

var roundTo = function (number, digits, towardZero) {
    if (typeof towardZero === 'undefined') {
        towardZero = false;
    }
    var factor = Math.pow(10, digits),
        rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
};

var deepClone = function (obj) {
    return JSON.parse(JSON.stringify(obj));
};

var sortListOfObjectsBy = function (list, key) {
    var comparator = function (a, b) {
        var a = a[key];
        var b = b[key];
        var comparisonType = typeof(a) === 'string' || typeof(b) === 'string' ? 'string' : 'number';
        return comparisonType === 'string' ? a.localeCompare(b) : a - b;
    }
    return list.sort(comparator);
};
var generateUUIDv4 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

var isValidIban = function (value) {
    var ibanAppearsValid = value.match(/^([A-Z]{2})([0-9]{2})([0-9A-Z]{12,30})$/g) !== null;
    console.log({ "ibanAppearsValid" : ibanAppearsValid });
    return ibanAppearsValid;
};

var runHtml5IbanValidation = function (elm, noSpaces, runCheck) {
    var noSpaces = (typeof noSpaces !== 'undefined') ? noSpaces : false;
    var runCheck = (typeof runCheck !== 'undefined') ? runCheck : false;
    elm.value = elm.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    var checkValue = elm.value;
    console.log(checkValue);
    if (isValidIban(checkValue) === false) {
        elm.setAttribute('pattern', /^(THIS_IS_INVALID)$/);
        elm.reportValidity = true;
    } else {
        elm.removeAttribute('pattern');
    }
    if (noSpaces === true) {
        elm.value = elm.value.replace(/[^A-Z0-9]/g, '');
    } else {
        elm.value = elm.value.replace(/(.{4})/g, '$1 ').trim();
    }
    if (isValidIban(checkValue) === false && runCheck === true) {
        console.log('running check');
        checkHtml5Form(elm, event)
    }
};

var checkHtml5Form = function (elm, event) {
    var form = elm.closest('form');
    form.checkValidity();
    form.reportValidity();
};

var forEach = function (array, callback, scope) {
    for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]);
    }
};

var userAgentIsIos = function() {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
    }
    // iPad Pro
    return navigator.maxTouchPoints
        && navigator.maxTouchPoints > 2
        && /MacIntel/.test(navigator.platform);
};

var userAgentIsFirefox = function() {
    return /firefox/i.test(navigator.userAgent);
};

var disableAutoSubmitOnEnterFor = function (querySelectorsArray) {
    var querySelectorAll = querySelectorsArray.join(',');
    document.querySelectorAll(querySelectorAll).forEach(function(elm) {
        elm.addEventListener('keydown', function(ev) {
            if (ev.key === 'Enter') {
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
                this.blur();
                return false;
            } else {
                return true;
            }
        }, false);
    });
};

dispatchAfterJqueryHasLoaded(function () {
    // var _overlay = document.getElementById('menu--mobile-list');
    // if (_overlay != null) {
    //     var _clientY = null; // Remember Y position on touch start
    //     var isOverlayTotallyScrolled = function () {
    //         // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    //         return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
    //     }
    //     var disableRubberBand = function (event) {
    //         var clientY = event.targetTouches[0].clientY - _clientY;
    //         if (_overlay.scrollTop === 0 && clientY > 0) {
    //             // Element is at the top of its scroll
    //             event.preventDefault();
    //         }
    //         if (isOverlayTotallyScrolled() && clientY < 0) {
    //             // Element is at the top of its scroll
    //             event.preventDefault();
    //         }
    //     };
    //     _overlay.addEventListener('touchstart', function (event) {
    //         if (event.targetTouches.length === 1) {
    //             // Detect single touch
    //             _clientY = event.targetTouches[0].clientY;
    //         }
    //     }, false);
    //     _overlay.addEventListener('touchmove', function (event) {
    //         if (event.targetTouches.length === 1) {
    //             // Detect single touch
    //             disableRubberBand(event);
    //         }
    //     }, false);
    // }

    $('#cookie-disclaimer-box-hide-action').on('click touch', function () {
        $('#cookie-disclaimer-box').addClass('d-none');
        $.post('/api/users/xhr-accept-cookies', function () {
            //console.log('success');
        })
            .done(function () {
                //console.log('second success');
            })
            .fail(function () {
                //console.log('error');
            })
            .always(function () {
                //console.log('finished');
            })
            ;
    });
});

// var disableEventsFn = function(event) {
//     event.preventDefault();
//     event.stopImmediatePropagation();
//     event.stopPropagation();
//     return false;
// };

// var disableUserEventsOnDisabledElements = function() {
//     document.querySelectorAll("[disabled], :disabled, .fieldset-disabled, .label-disabled, .button-disabled").forEach(function(elem) {
//         elem.addEventListener('mouseenter', disableEventsFn, {capture: true});
//         elem.addEventListener('mouseover', disableEventsFn, {capture: true});
//         elem.addEventListener('touchstart', disableEventsFn, {capture: true});
//         elem.addEventListener('click', disableEventsFn, {capture: true});
//         elem.addEventListener('input', disableEventsFn, {capture: true});
//     });
// }

// var enableUserEventsOnDisabledElements = function() {
//     document.querySelectorAll("[disabled], :disabled, .fieldset-disabled, .label-disabled, .button-disabled").forEach(function(elem) {
//         elem.removeEventListener('mouseenter', disableEventsFn);
//         elem.removeEventListener('mouseover', disableEventsFn);
//         elem.removeEventListener('touchstart', disableEventsFn);
//         elem.removeEventListener('click', disableEventsFn);
//         elem.removeEventListener('input', disableEventsFn);
//     });
// }

// window.addEventListener('load', disableUserEventsOnDisabledElements);
// document.addEventListener("DOMContentLoaded", disableUserEventsOnDisabledElements);


// See: https://funwithforms.com/posts/submit-vs-requestsubmit/
// See: https://caniuse.com/mdn-api_htmlformelement_requestsubmit
// See: https://github.com/javan/form-request-submit-polyfill/blob/main/form-request-submit-polyfill.js
(function(prototype) {
    if (typeof prototype.requestSubmit == "function") return

    prototype.requestSubmit = function(submitter) {
      if (submitter) {
        validateSubmitter(submitter, this)
        submitter.click()
      } else {
        submitter = document.createElement("input")
        submitter.type = "submit"
        submitter.hidden = true
        this.appendChild(submitter)
        submitter.click()
        this.removeChild(submitter)
      }
    }

    function validateSubmitter(submitter, form) {
      submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'")
      submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button")
      submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError")
    }

    function raise(errorConstructor, message, name) {
      throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name)
    }
  })(HTMLFormElement.prototype);

  const base64toBlob = function (b64Data, contentType, sliceSize) {
    contentType = (typeof contentType !== 'undefined') ?  contentType : ""
    sliceSize = (typeof sliceSize !== 'undefined') ?  sliceSize : 512

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    let offset = 0;
    for (offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        let i = 0;
        for (i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});

    return blob;
};

// https://derkuba.de/content/posts/1221/ios-safari-pdf-im-neuen-tab/
// https://ourcodeworld.com/articles/read/682/what-does-the-not-allowed-to-navigate-top-frame-to-data-url-javascript-exception-means-in-google-chrome
// https://stackoverflow.com/a/16245768
// https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
// https://stackoverflow.com/a/65148848
const openBase64PdfBinaryInNewTab = function (fileName, base64String) {
    const blob = base64toBlob(base64String, "application/pdf");
    const url = URL.createObjectURL(blob);
    const newTab = window.open();
    newTab.location = url;
    window.setTimeout(function() {
        newTab.document.title = fileName + ".pdf";
    }, 100);
};
